import { render, staticRenderFns } from "./OrderRefundModal.vue?vue&type=template&id=2a1efa90&"
import script from "./OrderRefundModal.vue?vue&type=script&lang=js&"
export * from "./OrderRefundModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports